import React from 'react';
import { useSelector } from 'react-redux';
import { LibraryGoalTarget } from './libraryGoalTarget';
import { LibraryGoalOption } from './libraryGoalOption';
import { goalDataTypeEnums } from 'utils';

export const LibraryGoalTargetDetail = ({}) => {
    const { goalById } = useSelector((state) => ({
        goalById: state.library.goalById,
    }));

    return (
        <div>
            <LibraryGoalTarget />

            {goalById?.dataType !== goalDataTypeEnums?.DURATION &&
                goalById?.dataType !== goalDataTypeEnums?.FREQUENCY &&
                goalById?.dataType !== goalDataTypeEnums?.SCORE &&
                goalById?.dataType !== goalDataTypeEnums?.RATE &&
                goalById?.dataType !== goalDataTypeEnums?.IRT &&
                <LibraryGoalOption />
            }
        </div>
    );
};
